export default "__VITE_ASSET__610c59a4__"